/**
 * Pinia Installer
 * 状态管理插件安装器
 */

import type { App } from 'vue'
import { createPinia } from 'pinia'

export const installPinia =  (app: App<Element>) => {
  const pinia = createPinia()

  app.use(pinia)

  console.log('🍊 Pinia installed')

  return pinia
}

